<div class="pilot-pay-categories-details">
	<div class="pp-toolbar">
		<div fxFlex fxLayoutAlign="center center" fxLayoutGap="5px" fxLayout.xs="column" fxLayout.lg="row">
			<div *ngIf="!hasFutureChange; else futureChangeMessage">
				<span class="vertical-middle">Changes go into effect on: </span>
				<mat-form-field>
					<mat-select [(value)]="effectiveStartDate">
						<mat-option *ngFor="let t of payPeriods" [value]="t">
							{{ t.externalFormat }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<ng-template #futureChangeMessage>
				<mat-error class="vertical-middle"
					>No edits can be made to this pay scale while it has a future change or scheduled
					deletion.</mat-error
				>
			</ng-template>
			<div fxFlex></div>
			<button
				*ngIf="!isNeedDiscard || hasFutureChange"
				class="form-button"
				type="button"
				color="grey"
				mat-raised-button
				(click)="navigate()"
			>
				Back to List
			</button>
			<div fxLayoutGap="5px" fxLayout.xs="row">
				<button
					*ngIf="isNeedDiscard && !hasFutureChange"
					class="form-button"
					color="blue"
					type="button"
					mat-raised-button
					(click)="navigate()"
				>
					Cancel
				</button>
				<button
					*ngIf="isNeedDiscard && payScaleId === 0"
					class="form-button"
					color="blue"
					type="button"
					mat-raised-button
					(click)="createPayScale()"
				>
					Save New
				</button>
			</div>
			<button
				*ngIf="isNeedDiscard && payScaleId !== 0 && !hasFutureChange"
				class="form-button"
				color="blue"
				type="button"
				mat-raised-button
				(click)="updatePayScale()"
			>
				Save Changes
			</button>
		</div>
	</div>
	<div class="mt-1 mb-1">
		<div class="details-form" fxLayout.xs="column">
			<div fxFlex.gt-sm="55%" fxFlex="100">
				<app-pay-scales-details-card
					(onChange)="isNeedChange($event)"
					[payScale]="payScale"
					[effectiveStart]="effectiveStartDate"
				></app-pay-scales-details-card>
			</div>
			<div fxFlex.gt-sm="45%" fxFlex="100">
				<app-pay-scales-settings-card
					(onChange)="isNeedChange($event)"
					[payScale]="payScale"
				></app-pay-scales-settings-card>
			</div>
		</div>
	</div>
	<app-pay-scales-years-of-service-card
		[isAddRecord]="isAddRecord"
		[isApRatingPayScale]="payScale.isApRatingPayScale"
		[isInstructorPayScale]="payScale.isInstructorPayScale"
		[payScale]="payScale"
		(onChange)="onYearOfServiceRecordsChange($event)"
	>
	</app-pay-scales-years-of-service-card>
	<div fxLayout="row" *ngIf="payScaleChanges && payScaleChanges.length">
		<div fxFlex.gt-sm="100%" fxFlex="100">
			<mat-card class="expander">
				<mat-card-title>
					<div>Future Changes</div>
					<div fxFlex></div>
					<button
						type="button"
						mat-icon-button
						class="ml-1"
						*ngIf="payScaleChanges && payScaleChanges.length"
						(click)="deletePayScaleFutureChanges()"
					>
						<mat-icon class="grey">delete</mat-icon>
					</button>
					<button
						type="button"
						mat-icon-button
						class="ml-1"
						(click)="futureChangesToggle = !futureChangesToggle"
					>
						<mat-icon *ngIf="!futureChangesToggle">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="futureChangesToggle">keyboard_arrow_up</mat-icon>
					</button>
				</mat-card-title>
				<hr />
				<div [hidden]="!futureChangesToggle">
					<app-changes-display [history]="payScaleChanges"></app-changes-display>
				</div>
			</mat-card>
		</div>
	</div>
	<div fxLayout="row" *ngIf="payScaleHistory && payScaleHistory.length">
		<div fxFlex.gt-sm="100%" fxFlex="100">
			<mat-card class="expander">
				<mat-card-title>
					<div>History</div>
					<div fxFlex></div>
					<button type="button" mat-icon-button class="ml-1" (click)="historyToggle = !historyToggle">
						<mat-icon *ngIf="!historyToggle">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="historyToggle">keyboard_arrow_up</mat-icon>
					</button>
				</mat-card-title>
				<hr />
				<div [hidden]="!historyToggle">
					<app-changes-display [history]="payScaleHistory"></app-changes-display>
				</div>
			</mat-card>
		</div>
	</div>
</div>
